import "swiper/swiper-bundle.css";

import { Autoplay, EffectFade, Navigation } from "swiper/modules";

import Swiper from "swiper";

Array.from(document.querySelectorAll(".centred-portrait-image.swiper")).map(
	(centeredImage) => {
		const swiper = new Swiper(centeredImage, {
			modules: [EffectFade, Autoplay, Navigation],
			autoplay: {
				delay: 7500,
			},
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			loop: true,
			navigation: {
				nextEl: ".swiper-next",
				prevEl: ".swiper-previous",
			},
		});
	}
);
